import { useMutation } from "@tanstack/react-query";
import { useToast } from "../../../components/ui/use-toast";
import { verifyOTP, fetchJWT } from "../../../services/auth";
import { ErrorType } from "../../../types";

export function useFetchJWT() {
  const { toast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: fetchJWT,
    onSuccess: (data) => {
      // No toast notification to avoid UX clutter
    },
    onError: (err: ErrorType) => {
      toast({
        title: "Failed to fetch JWT",
        description: err.response?.data?.description || "An error occurred",
        variant: "destructive",
      });
    },
  });

  return {
    fetchJWT: mutate,
    isPending,
  };
}

export function useVerifyOTP() {
  const { toast } = useToast();

  const { mutate, isPending, data } = useMutation({
    mutationFn: verifyOTP,
    onSuccess: (data: { message: string; token: string; refreshToken: string; sessionId: string }) => {
      toast({
        title: data.message || "OTP verified successfully",
      });
    },
    onError: (err: ErrorType) => {
      toast({
        title: "Failed to verify OTP",
        description: err.response?.data?.message || err.response?.data?.description || "An error occurred while verifying the OTP",
        variant: "destructive",
      });
    },
  });

  return {
    verifyOTP: mutate,
    data,
    isPending,
  };
}